import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconTrophy3 = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 24 24'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M20.000,8.863 L20.000,10.000 C20.000,14.072 16.940,17.436 13.000,17.931 L13.000,22.000 L17.000,22.000 C17.553,22.000 18.000,22.448 18.000,23.000 C18.000,23.552 17.553,24.000 17.000,24.000 L7.000,24.000 C6.447,24.000 6.000,23.552 6.000,23.000 C6.000,22.448 6.447,22.000 7.000,22.000 L11.000,22.000 L11.000,17.931 C7.060,17.436 4.000,14.072 4.000,10.000 L4.000,8.863 C1.655,8.236 0.000,5.491 0.000,3.000 C0.000,2.448 0.447,2.000 1.000,2.000 L4.000,2.000 L4.000,1.000 C4.000,0.448 4.447,0.000 5.000,0.000 L19.000,0.000 C19.553,0.000 20.000,0.448 20.000,1.000 L20.000,2.000 L23.000,2.000 C23.553,2.000 24.000,2.448 24.000,3.000 C24.000,5.491 22.345,8.236 20.000,8.863 ZM4.000,4.000 L2.129,4.000 C2.408,5.123 3.118,6.215 4.000,6.715 L4.000,4.000 ZM18.000,2.000 L6.000,2.000 L6.000,10.000 C6.000,13.309 8.691,16.000 12.000,16.000 C15.309,16.000 18.000,13.309 18.000,10.000 L18.000,2.000 ZM20.000,4.000 L20.000,6.715 C20.883,6.215 21.592,5.123 21.871,4.000 L20.000,4.000 ZM13.000,13.000 L11.000,13.000 C10.447,13.000 10.000,12.552 10.000,12.000 C10.000,11.448 10.447,11.000 11.000,11.000 L11.000,8.414 L10.707,8.707 C10.316,9.098 9.684,9.098 9.293,8.707 C8.902,8.317 8.902,7.684 9.293,7.293 L11.293,5.293 C11.580,5.007 12.009,4.922 12.383,5.076 C12.757,5.231 13.000,5.596 13.000,6.000 L13.000,11.000 C13.553,11.000 14.000,11.448 14.000,12.000 C14.000,12.552 13.553,13.000 13.000,13.000 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconTrophy3.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
